/* eslint-disable camelcase */

import React from 'react'
import PropTypes from 'prop-types'
import { formatDate } from '../../utils/dateHelpers'
import { pluralize } from '../../utils/textHelpers'
import ArrowRightIcon from '../ui/icons/ArrowRightIcon'

const CARD = 'tw:flex tw:items-center tw:justify-between tw:gap-4 tw:bg-white '
  + 'tw:border tw:border-solid tw:border-gray-300 tw:rounded-lg! tw:px-4 tw:py-2.5'
const ACCESS_LINK = 'tw:flex tw:items-center tw:gap-2 tw:shrink-0 tw:text-sm tw:font-medium '
  + 'tw:text-gray-800 tw:no-underline! tw:hover:text-gray-900'

const EnsembleCard = ({ ensemble }) => (
  <div className="tw:flex tw:flex-col tw:gap-2">
    <span className="tw:text-sm tw:text-gray-700">Ensemble</span>
    <div className={CARD}>
      <div className="tw:flex tw:flex-col tw:gap-0.5 tw:min-w-0">
        <div className="tw:flex tw:items-center tw:gap-2 tw:text-sm tw:font-medium tw:text-gray-700">
          <i className="fas fa-cubes" />
          <span className="tw:truncate">{ensemble.name}</span>
        </div>
        <div className="tw:text-xs tw:text-gray-400 tw:leading-snug">
          <div>{`Créé le ${formatDate(ensemble.created_at)}`}</div>
          <div>
            {pluralize(ensemble.resources_count, 'ressource')}
            {ensemble.has_address ? ' avec adresses' : ''}
          </div>
        </div>
      </div>
      <a href={`/ensembles/${ensemble.id}/resources`} className={ACCESS_LINK}>
        Accéder
        <ArrowRightIcon className="tw:w-3 tw:h-3" />
      </a>
    </div>
  </div>
)

EnsembleCard.propTypes = {
  ensemble: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    created_at: PropTypes.string,
    resources_count: PropTypes.number,
    has_address: PropTypes.bool
  }).isRequired
}

export default EnsembleCard
